export const initPreventRightClickOnBlogs = () => {
  const blogTagsAndCategories = document.getElementById('blog-categories');
  if(!blogTagsAndCategories) {
      return;
  }

  const stopRightClick = (e) => e.preventDefault();

  const tags = blogTagsAndCategories.getAttribute('data-tags').split(',');
  const categories = blogTagsAndCategories.getAttribute('data-categories').split(',');
  if(tags.indexOf('Client Review') >= 0 || categories.indexOf('Reviews') >= 0) {
    Array.from(document.getElementsByTagName('img')).forEach(x => x.addEventListener('contextmenu', stopRightClick));
  }
};
